import React from 'react';
import { Button, Row, Col } from 'antd';
import './FooterButtonGroup.scss';

interface FooterButtonGroupProps {
  onCancel?: () => void;
  onContinue: () => void;
  isSubmitting?: boolean;
  isContinueDisabled?: boolean;
  cancelText?: string;
  continueText?: string;
  isVerticalInMobile?: boolean;
}

const FooterButtonGroup: React.FC<FooterButtonGroupProps> = ({
  onCancel,
  onContinue,
  isSubmitting = false,
  isContinueDisabled = false,
  cancelText,
  continueText,
  isVerticalInMobile = true,
}) => {
  const hasCancelButton = !!cancelText;

  return (
    <div className="footer-button-group-container">
      <Row className="form-footer" gutter={[24, 24]}>
        {hasCancelButton && (
          <Col xs={isVerticalInMobile ? 24 : 12} sm={12} className="form-footer-col">
            <Button
              className="cancel-button"
              color="primary"
              variant="outlined"
              size="large"
              disabled={isSubmitting}
              onClick={onCancel}
            >
              {cancelText}
            </Button>
          </Col>
        )}

        <Col
          xs={isVerticalInMobile ? 24 : 12}
          sm={hasCancelButton ? 12 : 24}
          className={`form-footer-col ${
            !hasCancelButton ? 'single-button-col' : ''
          }`}
        >
          <Button
            className="continue-button"
            type="primary"
            size="large"
            loading={isSubmitting}
            onClick={onContinue}
            disabled={isContinueDisabled}
          >
            {continueText}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default FooterButtonGroup;
